// src/styles/theme.js
const theme = {
  color: {
    /* Warm-neutral stone base — from the E-commerce Luxury palette.
       Cooler greys make skin-tone and pigment swatches look wrong. */
    ink: "#0C0A09",
    inkSoft: "#1C1917",
    body: "#44403C",
    muted: "#78716C",
    line: "#E7E5E4",
    lineSoft: "#F5F5F4",
    bg: "#FFFFFF",
    bgSoft: "#FAFAF9",
    bgDark: "#0C0A09",

    /* Single accent. The generated system suggested gold; swapped for a
       cleaner crimson so the site still reads as LaBina. */
    brand: "#E11D48",
    brandDark: "#BE123C",
    brandSoft: "#FFF1F3",

    ok: "#059669",
    okSoft: "#ECFDF5",
    warn: "#B45309",
    warnSoft: "#FFFBEB",
    danger: "#DC2626",
    dangerSoft: "#FEF2F2",
    white: "#FFFFFF",
  },

  font: {
    sans: `"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    display: `"Outfit", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
  },

  size: {
    xs: "clamp(0.75rem, 0.73rem + 0.1vw, 0.8rem)",
    sm: "clamp(0.86rem, 0.84rem + 0.12vw, 0.925rem)",
    base: "clamp(0.97rem, 0.94rem + 0.18vw, 1.05rem)",
    lg: "clamp(1.08rem, 1.02rem + 0.3vw, 1.22rem)",
    xl: "clamp(1.32rem, 1.16rem + 0.7vw, 1.72rem)",
    h3: "clamp(1.6rem, 1.3rem + 1.2vw, 2.25rem)",
    h2: "clamp(2.1rem, 1.55rem + 2.4vw, 3.4rem)",
    h1: "clamp(2.75rem, 1.75rem + 4.4vw, 5.4rem)",
  },

  weight: { light: 300, regular: 400, medium: 500, semi: 600, bold: 700 },

  space: (n) => `${n * 4}px`,

  /* Softer, larger radii — the single biggest "is this from 2016 or now" tell */
  radius: {
    xs: "8px",
    sm: "10px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    pill: "999px",
  },

  /* Layered, low-opacity shadows instead of one grey blur */
  shadow: {
    xs: "0 1px 2px rgba(12,10,9,0.04)",
    sm: "0 2px 4px rgba(12,10,9,0.04), 0 1px 2px rgba(12,10,9,0.03)",
    md: "0 8px 16px -4px rgba(12,10,9,0.06), 0 4px 8px -4px rgba(12,10,9,0.04)",
    lg: "0 24px 48px -12px rgba(12,10,9,0.12), 0 8px 16px -8px rgba(12,10,9,0.06)",
    focus: "0 0 0 3px rgba(225,29,72,0.14)",
  },

  ease: {
    out: "cubic-bezier(0.22, 1, 0.36, 1)",
    inOut: "cubic-bezier(0.65, 0, 0.35, 1)",
    spring: "cubic-bezier(0.34, 1.56, 0.64, 1)",
  },

  layout: {
    maxWidth: "1320px",
    gutter: "clamp(20px, 5vw, 72px)",
    navHeight: "72px",
    section: "clamp(72px, 9vw, 140px)",
  },

  bp: { sm: "540px", md: "768px", lg: "1024px", xl: "1280px" },
};

theme.down = Object.fromEntries(
  Object.entries(theme.bp).map(([k, v]) => [k, `@media (max-width: ${v})`]),
);
theme.up = Object.fromEntries(
  Object.entries(theme.bp).map(([k, v]) => [k, `@media (min-width: ${v})`]),
);

export default theme;
